import React from 'react';
import PropTypes from 'prop-types';
import { lowercaseHyphen } from '../../utils/stringConversion';
import contentTypeName, { contentTypePlural } from '../../utils/contentTypeName';

const SearchHeading = ({ searchQuery, searchResults }) => {
  let searchTerm = contentTypeName(searchQuery.term);
  let numberOfResults = 0;

  if (searchQuery.primaryFilter === `all`) {
    numberOfResults = searchResults.results.length;
  } else {
    if (searchQuery.term === ``) {
      searchTerm = `All`;
    }

    const activeFilter = searchResults.result_count.find(filter => contentTypeName(filter.itemName) === contentTypeName(searchQuery.primaryFilter));
    // If the active filter is actually a valid filter
    if (activeFilter) {
      numberOfResults = activeFilter.itemCount;
    }
  }

  return (
    <h1 className="like-h1 fw-medium text-capitalize m-b-5">
      <span className="visuallyhidden">Search </span>
      {`${searchTerm} `}
      <span className={`color-grey color-${lowercaseHyphen(searchQuery.primaryFilter)}`}>
        {contentTypePlural(contentTypeName(searchQuery.primaryFilter))}
      </span>
    </h1>
  );
};

SearchHeading.propTypes = {
  searchQuery: PropTypes.object.isRequired,
  searchResults: PropTypes.object.isRequired,
};

export default SearchHeading;



// WEBPACK FOOTER //
// ./library/app/components/Search/SearchHeading.js